import dayjs from "dayjs";
import { normalizeAlbumPath } from "./deliveryPath";
import { parseConsentClauseIds, stringifyConsentClauseIds } from "./deliveryConsent";

export function defaultExpiry() {
    return dayjs().add(30, "day").hour(23).minute(59).second(59).millisecond(0);
}

export function emptyVideoReviewFormValues() {
    return {
        videoPath: "",
        videoName: "",
        consentClauses: parseConsentClauseIds("general"),
        commentVisibility: "shared",
        expiry: defaultExpiry(),
    };
}

export function videoReviewToFormValues(item) {
    return {
        videoPath: item.videoPath || "",
        videoName: item.videoName || "",
        consentClauses: parseConsentClauseIds(item.consent),
        commentVisibility: item.commentVisibility === "individual" ? "individual" : "shared",
        expiry: item.expiry ? dayjs(item.expiry * 1000) : defaultExpiry(),
    };
}

function isValidVideoPath(path) {
    const normalized = normalizeAlbumPath(path);
    if (!normalized || normalized.includes("..")) {
        return false;
    }
    if (/[\0\r\n\\]/.test(normalized)) {
        return false;
    }
    return true;
}

export function validateVideoReviewForm(values, t) {
    const videoPath = normalizeAlbumPath(values.videoPath);
    const videoName = (values.videoName || "").trim();

    if (!videoName) {
        throw new Error(t("videoReview.admin.videoNameRequired"));
    }
    if (!videoPath) {
        throw new Error(t("videoReview.admin.pathRequired"));
    }
    if (!isValidVideoPath(videoPath)) {
        throw new Error(t("videoReview.admin.pathInvalid"));
    }
    if (!values.expiry) {
        throw new Error(t("videoReview.admin.expiryMustBeFuture"));
    }
    const expiry = Math.floor(values.expiry.valueOf() / 1000);
    if (expiry * 1000 <= Date.now()) {
        throw new Error(t("videoReview.admin.expiryMustBeFuture"));
    }

    return {
        videoPath,
        videoName,
        expiry,
        consent: stringifyConsentClauseIds(values.consentClauses),
        commentVisibility: values.commentVisibility === "individual" ? "individual" : "shared",
    };
}
